// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:22
import { ServiceResourceLight_abstract } from './../abstract/SagaSchema/ServiceResourceLight_abstract';
export class ServiceResourceLight extends ServiceResourceLight_abstract {}
